import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import instance from "../instance"; // Your Axios instance

// Fetch Assignments (if needed for viewing/listing)
export const useFetchAssignments = (filters) => {
    const fetchAssignments = async () => {
      const { data } = await instance.get(`/api/assignments?pageNumber=${filters?.pageNumber}&pageSize=${filters?.pageSize}`); // Your API endpoint
      return data;
    };
  
    const query = useQuery({
      queryKey: ['fetch assignments', filters],
      queryFn: fetchAssignments,
    });
  
    return query;
  };

// Add Assignment
export const useAddAssignment = () => {
  const queryClient = useQueryClient();
  const addAssignmentMutation = useMutation(async (newAssignment) => {
    const { data } = await instance.post('/api/assignments', newAssignment); // Your API endpoint
    return data;
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetch assignments']); // Refetch assignments after adding
    },
  });

  return addAssignmentMutation;
};


export const useUpdateAssignment = () => {
    const queryClient = useQueryClient();
    const updateAssignmentMutation = useMutation(async (updatedAssignment) => {
      const { data } = await instance.put(`/api/assignments/${updatedAssignment.id}`, updatedAssignment); // Include ID in URL
      return data;
    }, {
      onSuccess: () => {
        queryClient.invalidateQueries(['fetch assignments']); // Refetch assignments
      },
      onError: (error) => {
        console.error("Error updating assignment:", error); // Handle errors
        // You might want to display an error message to the user here
      },
    });
  
    return updateAssignmentMutation;
  };
  
  // Delete Assignment
  export const useDeleteAssignment = () => {
    const queryClient = useQueryClient();
    const deleteAssignmentMutation = useMutation(async (assignmentId) => {
      await instance.delete(`/api/assignments/${assignmentId}`); // Include ID in URL
    }, {
      onSuccess: () => {
        queryClient.invalidateQueries(['fetch assignments']); // Refetch assignments
      },
      onError: (error) => {
        console.error("Error deleting assignment:", error); // Handle errors
        // You might want to display an error message to the user here
      },
    });
  
    return deleteAssignmentMutation;
  };